import React, { Component } from "react";
import {
  FormControlLabel,
  Checkbox,
  WithStyles,
  withStyles,
  Grid,
} from "@material-ui/core";
import { userStyles } from "../styles";
import CancelIcon from "@material-ui/icons/Cancel";

interface AutocompleteProps extends WithStyles<typeof userStyles> {
  valueAutoComp: any;
  options: any;
  onChange: any;
  isMulti: any;
  optionsList?: any;
  placeholderText: string
}

export class Autocomplete extends Component<AutocompleteProps> {
  constructor(props: AutocompleteProps) {
    super();
  }

  state = {
    activeOption: 0,
    filteredOptions: [],
    showOptions: false,
    userInput: "",
    multiSelectValues: [],
    optionList: null,
    placeholder: ''
  };

  componentDidUpdate(prevProps: any) {
    if (prevProps.valueAutoComp !== this.props.valueAutoComp) {
      if (!this.props.isMulti && this.props.valueAutoComp === "") {
        this.setState({
          userInput: "",
          multiSelectValues: []
        });
      } 
      if (this.props.isMulti && this.props.valueAutoComp && this.props.valueAutoComp.length === 0) {
        this.setState({
          userInput: "",
          multiSelectValues: [],
          placeholder: 'Search and Select subjects'

        });
      } 
      if(this.props.isMulti && this.props.valueAutoComp && this.props.valueAutoComp.length > 0) {
        let subjectListName =
          this.props.valueAutoComp &&
          this.props.valueAutoComp.map((ele: any) => ele.name || ele);
        this.setState({
          multiSelectValues: subjectListName,
        });
      }
    }

    if (prevProps.isMulti !== this.props.isMulti) {
      this.setState({
        placeholder: 'Search and Select subjects'
      });
    } 
  }

  onChange = (e: any) => {
    this.props.onChange(e.currentTarget.value);
    const { options } = this.props;
    const userInput = e.currentTarget.value;
    let filteredOptions: any;
    if(!this.props.isMulti){
    filteredOptions = userInput.length > 2 ? options.filter((optionName: any) =>
    optionName.toLowerCase().includes(userInput.toLowerCase())) : [];
    } else {
      filteredOptions = userInput.length > 0? options.filter((optionName: any) =>
      optionName.toLowerCase().startsWith(userInput.toLowerCase())) : [];
    }
    this.setState({
      activeOption: 0,
      filteredOptions: filteredOptions,
      showOptions: true,
      userInput:
        this.state.multiSelectValues.length === 1 && !this.props.isMulti
          ? ""
          : e.currentTarget.value,
    },
    ()=> {
      this.renderOptions();
    });
  };

  onClick = (e: any) => {
    e.preventDefault();
    let value: any = this.state.multiSelectValues
    ? this.state.multiSelectValues
    : [];
    value.push(e.currentTarget.innerText);
    if(this.props.isMulti) {
      this.props.onChange(e.currentTarget.innerText,value);

    } else {
      this.props.onChange(e.currentTarget.innerText);

    }
    this.setState({
      activeOption: 0,
      filteredOptions: [],
      showOptions: false,
      multiSelectValues: value,
      userInput: ""
    });
  };
  onKeyDown = (e: any) => {
    const { activeOption, filteredOptions } = this.state;

    // event for enter key
    if (e.keyCode === 13) {
      let value: any = this.state.multiSelectValues
      ? this.state.multiSelectValues
      : [];
      value.push(filteredOptions[activeOption]);
      if(this.props.isMulti) {
        this.props.onChange(filteredOptions[activeOption],value);
  
      } else {
        this.props.onChange(filteredOptions[activeOption]);
  
      }
      this.setState({
        activeOption: 0,
        filteredOptions: [],
        showOptions: false,
        multiSelectValues: value,
        userInput: ""
      });
      // this.props.onChange(filteredOptions[activeOption]);

      // event for up arrow key
    } else if (e.keyCode === 38) {
      if (activeOption === 0) {
        return;
      }
      this.setState({ activeOption: activeOption - 1 });
      // event for down arrow key
    } else if (e.keyCode === 40) {
      if (activeOption === filteredOptions.length - 1) {
        return;
      }
      this.setState({ activeOption: activeOption + 1 });
    } else if (e.keyCode === 8) {
      // event for backspace
      this.props.onChange(e.currentTarget.value);
    }
  };

  removeEle(ele: any) {
    let list = this.state.multiSelectValues;
    let inputValue = this.state.userInput;
    const index = list.findIndex((item: any) => item === ele);
    list.splice(index, 1);

    inputValue = list.length === 0 ? "" : inputValue;

    this.setState(
      {
        multiSelectValues: list,
        userInput: inputValue,
      },
      () => {
        if (this.props.isMulti) {
          this.props.onChange(
            this.state.userInput,
            this.state.multiSelectValues
          );
        } else {
          this.props.onChange(this.state.userInput);
        }
      }
    );
  }
  renderOptions() {
    const { classes } = this.props;
  if(this.state.showOptions && this.state.userInput && this.state.filteredOptions.length) {
    return(
      <ul className="options">
        {this.state.filteredOptions.map((optionName, index) => {
          let className;
          if (index === this.state.activeOption) {
            className = "option-active";
          }
          if (this.props.isMulti) {
            return (
              <li className={className} key={optionName} onClick={this.onClick}>
                <FormControlLabel
                  className={[classes.customRadio, classes.marginZero].join(
                    " "
                  )}
                  control={
                    <Checkbox
                      checked={
                        !this.props.isMulti
                          ? false
                          : this.state.multiSelectValues.includes(optionName)
                      }
                      classes={{
                        root: classes.checkbox,
                        checked: classes.checkedCheckbox,
                        colorPrimary: classes.primaryColor,
                      }}
                      color="primary"
                      disableRipple
                    />
                  }
                  value={optionName}
                  label={optionName}
                  classes={{
                    label: [classes.fontSize_SM, classes.grey].join(" "),
                  }}
                />
              </li>
            );
          } else {
            return (
              <li className={className} key={optionName} onClick={this.onClick}>
               {optionName}
              </li>
            );
          }
        }
        )}
      </ul>
    )}
    if(this.state.showOptions && this.state.userInput && !this.state.filteredOptions.length && ((!this.props.isMulti && this.state.userInput.length > 2) || (this.props.isMulti && this.state.userInput.length > 0))) {
      return (
        <ul className="options">
              <li>
          <span className={[classes.fontSize_SM, classes.grey].join(" ")}>No Result Found</span>
              </li>
        </ul>
      );
    }
  }

  render() {
    const { classes } = this.props;
    const {
      onChange,
      onClick,
      onKeyDown,

      state: { userInput },
    } = this;

    return (
      <>
        <div className="search">
          <div className="chipInput">
            <div className="chipContainer">
              {this.state.multiSelectValues &&
                this.state.multiSelectValues.map((ele: any) => {
                  return (
                    <span className={classes.customChip}>
                      <span className="chipLabel"> {ele} </span>
                      <span
                        className="chipIcon"
                        onClick={() => this.removeEle(ele)}
                      >
                        {" "}
                        <CancelIcon />
                      </span>
                    </span>
                  );
                })}
            </div>
            <div className="search-input-field">
              <input
                type="text"
                className={
                  !this.props.isMulti &&
                  this.state.multiSelectValues.length === 1 ? classes.hideInput : ' '
                }
                onChange={onChange}
                onKeyDown={onKeyDown}
                value={userInput}
                placeholder={
                  this.state.multiSelectValues.length > 0 ? "" : this.props.placeholderText}
                disabled={
                  !this.props.isMulti &&
                  this.state.multiSelectValues.length === 1
                }
              />
            </div>
          </div>
          <span className="search-btn">
            <img
              src="/assets/svg/userManagement/search-icon.svg"
              alt="search"
            />
          </span>
        </div>
        {this.renderOptions()}
      </>
    );
  }
}

// @ts-ignore
export default withStyles(userStyles)(Autocomplete);
